import {ExtensionType} from 'graphql-client/__generated/graphqlGlobalTypes';

import type {Extension} from '../../content-store/extensionConstants';

export interface McpExtensionInstallContext {
  extensionType: ExtensionType.MCP_SERVER;
  urlParamValues: Record<string, string>;
  manualOAuthClientId: string;
  manualOAuthClientSecret: string;
}

/** Partial update for MCP install context fields (excluding the discriminant). */
export type McpExtensionInstallContextPatch = Partial<Omit<McpExtensionInstallContext, 'extensionType'>>;

export function patchMcpInstallContext(
  installContext: McpExtensionInstallContext,
  patch: McpExtensionInstallContextPatch
): McpExtensionInstallContext {
  return {
    ...installContext,
    ...patch,
    urlParamValues:
      patch.urlParamValues !== undefined
        ? {...installContext.urlParamValues, ...patch.urlParamValues}
        : installContext.urlParamValues,
  };
}

export function buildMcpInstallRequestBody(
  extension: Extension,
  installContext: McpExtensionInstallContext
): Record<string, unknown> {
  const body: Record<string, unknown> = {extensionType: extension.extensionType};
  const urlParams = extension.latestVersion?.mcpProperties?.urlParams ?? [];
  if (urlParams.length > 0) {
    body.urlParamValues = installContext.urlParamValues;
  }
  const cid = installContext.manualOAuthClientId.trim();
  const csec = installContext.manualOAuthClientSecret.trim();
  if (cid !== '' && csec !== '') {
    body.manualOAuthClientId = cid;
    body.manualOAuthClientSecret = csec;
  }
  return body;
}
